/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

export type ReportSectionStatus =
  (typeof ReportSectionStatus)[keyof typeof ReportSectionStatus];

export const ReportSectionStatus = {
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;
